/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-ignore next-line
window.depVersions = {
};
    